<template>
    <!-- <el-radio-group v-model="dataName" size="middle">
      <el-radio-button value="ele1" label="可运营专利" />
      <el-radio-button value="ele2" label="重点专利" />
    </el-radio-group> -->
  <p>可运营专利</p>
   <el-table ref="tableList" :data="tableData1" height="170"  style="width: 100%"  class="tablebox" tooltip-effect="dark myTooltips">
    <el-table-column prop="pubNumber" label="公开（公告）号" :show-overflow-tooltip="true" min-width="70"> 
      <template #default="scope">
        <a :href="scope.row.link" target="_blank" :style="{color:'#2C6AE8','textDecoration':'none'}">{{ scope.row.pubNumber }}</a>
      </template>
    </el-table-column>
    <el-table-column prop="title" label="标题"  :show-overflow-tooltip="true" min-width="140"> 
    </el-table-column>
    <el-table-column prop="apply" label="原始申请人" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="dever" label="发明人" :show-overflow-tooltip="true"> 
    </el-table-column>
  </el-table>
  <!-- <el-table :data="tableData2" height="200" style="width: 100%" :style="{marginTop: '15px'}" v-else tooltip-effect="dark myTooltips">
    <el-table-column prop="row1" label="公开（公告）号" :show-overflow-tooltip="true" min-width="150"> 
      <template #default="scope">
        <a :href="scope.row.link" target="_blank" :style="{color:'#2C6AE8','textDecoration':'none'}">{{ scope.row.row1 }}</a>
      </template>
    </el-table-column>
    <el-table-column prop="row2" label="申请号" :show-overflow-tooltip="true" min-width="180"> </el-table-column>
    <el-table-column prop="row3" label="申请日" :show-overflow-tooltip="true" min-width="120"> </el-table-column>
    <el-table-column prop="row4" label="标题" :show-overflow-tooltip="true" min-width="120"> 
    </el-table-column>
    <el-table-column prop="row5" label="当前申请(专利权)人" :show-overflow-tooltip="true" min-width="200">
     </el-table-column>
    <el-table-column prop="row6" label="法律有效性" :show-overflow-tooltip="true" min-width="120"> </el-table-column>
  </el-table> -->
</template>
<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
export default {
  name: "echartsBox",
  data(){
    return {
       dataName: 'ele1',
    }
  },
  setup() {
    let timer = null;
    const tableList = ref(null);
    /// 声明定义一下echart
    const tableData1 = ref([
     {
        pubNumber: 'CN105610824B',
        title:'一种基于屏幕镜像及RTSP流媒体框架的屏幕共享方法', 
        apply: '哈尔滨工业大学',
        dever: '金晶 | 周之锐 | 沈毅 | 王艳 | 鄂尔多斯',
        link:'https://www.himmpat.com/browse?ucid=CN-105610824-A&excelToken=new44478A69B3C7BA8CD9275FB2A65A1B13A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN105843783B',
        title:'一种面向网络流传输的中文PDF文件文本内容提取方法', 
        apply: '哈尔滨工程大学',
        dever: '王巍 | 杨武 | 苘大鹏 | 玄世昌 | 段茂涛',
        link:'https://www.himmpat.com/browse?ucid=CN-105843783-A&excelToken=new378BD94DD28F4A4A014C2B5DA49FDF85A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN108964731B',
        title:'基于快速卷积的无循环前缀滤波混合载波连续流传输方法', 
        apply: '哈尔滨工业大学',
        dever: '梅林 | 林旭 | 沙学军',
        link:'https://www.himmpat.com/browse?ucid=CN-108964731-A&excelToken=newB536C5227C6B21895AFD168179E2C2F0A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN114679606B',
        title:'一种基于Burst特征的视频流量识别方法、系统、电子设备及存储介质', 
        apply: '哈尔滨工业大学',
        dever: '余翔湛 | 刘立坤 | 史建焘 | 李精卫 | 葛蒙蒙 | 张晓慧 | 苗钧重 | 刘凡 | 韦贤葵 | 石开宇 | 王久金 | 冯帅 | 赵跃 | 宋赟祖 | 郭明昊 | 车佳臻',
        link:'https://www.himmpat.com/browse?ucid=CN-114679606-A&excelToken=new2B444E62444FB9DA18134F8C84898CBCA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN104618091B',
        title:'双混沌系统动态密钥与RSB联合的流媒体保密通信方法', 
        apply: '哈尔滨理工大学',
        dever: '康守强 | 王玉静 | 谢金宝 | 纪彬 | 兰朝凤 | 高华强',
        link:'https://www.himmpat.com/browse?ucid=CN-104618091-A&excelToken=new4A88FB998A5143C420B9D55623C27ADEA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN102489802B',
        title:'一种微冲压模具原位制造装置', 
        apply: '哈尔滨工业大学',
        dever: '徐杰 | 迟关心 | 王春举 | 王玉魁 | 郝智聪 | 单德彬 | 王振龙 | 郭斌',
        link:'https://www.himmpat.com/browse?ucid=CN-102489802-A&excelToken=new35C9E7431C2BD0D1FE652213D8D71B4BA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN111872169B',
        title:'一种高强度钛合金管坯的加工模具及加工方法', 
        apply: '哈尔滨工业大学',
        dever: '王克环 | 王东君 | 刘钢',
        link:'https://www.himmpat.com/browse?ucid=CN-111872169-A&excelToken=new31C72A369E911B0480CBEA6B9C109F90A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: ' CN109376475B ',
        title:'一种热阻网络法与有限差分法结合的多匝密绕线圈温度场计算方法', 
        apply: '哈尔滨工业大学',
        dever: '杨文英 | 李茹瑶 | 邱子澜 | 王茹 | 翟国富',
        link:'https://www.himmpat.com/browse?ucid=CN-109376475-A&excelToken=new0952E352C10950781485549C2D854E79A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: ' CN115745626B ',
        title:'一种氧化石墨烯改性SiBCN陶瓷温度传感器及其制备方法', 
        apply: '哈尔滨工业大学',
        dever: '严强 | 李金平 | 石皓帆 | 孟松鹤 | 易法军 | 解维华 | 许承海 | 方国东 | 杨强',
        link:'https://www.himmpat.com/browse?ucid=CN-115745626-A&excelToken=newD8F918539072E8146A1F37354D57FD2FA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: ' CN108344518B ',
        title:'一种致密型先驱体陶瓷温度传感器的制备方法', 
        apply: '哈尔滨工业大学',
        dever: '易法军 | 牛家宏 | 孟松鹤 | 金华 | 方国东 | 许承海 | 解维华',
        link:'https://www.himmpat.com/browse?ucid=CN-108344518-A&excelToken=newABBCD5F036BC888F99C3BCF16E2BA13AA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN105021303B ',
        title:'一种铝基敏感材料的温度传感器制造方法', 
        apply: '哈尔滨工程大学',
        dever: '张洪泉 | 高延滨 | 曾建辉 | 胡文彬 | 郭立东 | 霍亮 | 李光春 | 王军',
        link:'https://www.himmpat.com/browse?ucid=CN-105021303-A&excelToken=new427C3E2C63ED4CF54F23014F1903B996A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN110039406B ',
        title:'一种单晶硅光学复杂表面的超精密加工工具及加工方法', 
        apply: '哈尔滨工业大学',
        dever: '郭兵 | 王生 | 张俊 | 赵清亮 | 尹航',
        link:'https://www.himmpat.com/browse?ucid=CN-110039406-A&excelToken=newD223593F00CA109245201FAD32E4AD8BA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN114890780B ',
        title:'一种Y型六角铁氧体磁电耦合陶瓷材料及其制备方法', 
        apply: '哈尔滨工业大学',
        dever: '李均 | 赵东鹏 | 白晗 | 吴欢桐 | 许同同 | 周忠祥',
        link:'https://www.himmpat.com/browse?ucid=CN-114890780-A&excelToken=newDFD973B5FF5650AF2DD0336F2D6D8093A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN113683409B ',
        title:'具有优异温度稳定性的四方相B和B位共取代无铅压电织构陶瓷及其制备方法和应用', 
        apply: '哈尔滨工业大学',
        dever: '常云飞 | 寇蔷薇 | 刘琳婧 | 谢航 | 孙媛 | 杨彬',
        link:'https://www.himmpat.com/browse?ucid=CN-113683409-A&excelToken=newBF5EF194AA7AF2E12E6C665D0B1F56EBA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN105610824B',
        title:'一种室温顺电-铁电可调的陶瓷材料及其制备方法', 
        apply: '哈尔滨理工大学',
        dever: '徐丹 | 赵文杰 | 陈明华 | 刘刚',
        link:'https://www.himmpat.com/browse?ucid=CN-110357614-A&excelToken=new750C4C2659169FC00185E930CF606714A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN114835483B',
        title:'一种低损耗高储能效率铁酸铋基无铅反铁电陶瓷材料及其制备方法', 
        apply: '哈尔滨理工大学',
        dever: '徐丹 | 余涛林 | 赵文杰 | 赵宏 | 段晓阳',
        link:'https://www.himmpat.com/browse?ucid=CN-114835483-A&excelToken=new63DB8AAB3573EFE528749E02AE1A6540A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN104129984B',
        title:'一种金属表面非晶磷酸铝基耐高温透波陶瓷涂层的制备方法', 
        apply: '哈尔滨工业大学',
        dever: '王亚明 | 邹永纯 | 贾德昌 | 欧阳家虎 | 周玉',
        link:'https://www.himmpat.com/browse?ucid=CN-104129984-A&excelToken=new4DBC8B6CCD6D8C6F52D32131B3A42F56A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN108516827B',
        title:'一种无铅高介电储能密度和高储能效率的陶瓷材料及其制备方法', 
        apply: '哈尔滨工业大学',
        dever: '白晗 | 李均 | 洪杨 | 周忠祥 | 施扣忠',
        link:'https://www.himmpat.com/browse?ucid=CN-108516827-A&excelToken=newBA4AB488ADD2F17EEC17E2F8E459FFA4A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN107488035B',
        title:'一种钛酸钡基陶瓷材料中圆形晶粒与高长径比棒状晶粒比例的调节方法', 
        apply: '哈尔滨工业大学',
        dever: '李均 | 白晗 | 吴忧 | 周忠祥',
        link:'https://www.himmpat.com/browse?ucid=CN-107488035-A&excelToken=new270D5191A0CA9546851A6FB9FE670F20A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN105218076B',
        title:'一种利用溶胶凝胶法制备SrMnO3陶瓷粉体的方法', 
        apply: '哈尔滨工业大学',
        dever: '柯华 | 王猛 | 张洪军 | 张利伟 | 应鹏展 | 谢星驰 | 罗蕙佳代',
        link:'https://www.himmpat.com/browse?ucid=CN-105218076-A&excelToken=newA912C8EB6BCAEF301884CBADA18654DEA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN105948748B',
        title:'一种硅硼碳氮锆陶瓷复合材料及其制备方法', 
        apply: '哈尔滨工业大学',
        dever: '贾德昌 | 苗洋 | 杨治华 | 周玉',
        link:'https://www.himmpat.com/browse?ucid=CN-105948748-A&excelToken=newFF8787C358AE6FEB098D81E7FC396E79A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: ' CN110668809B ',
        title:'一种层状结构的铁掺杂钛酸钡基磁电陶瓷的制备方法', 
        apply: '哈尔滨工业大学',
        dever: '张洪军 | 吴春龙 | 柯华 | 李方喆 | 田晶鑫 | 唐晓慧 | 罗蕙佳代 | 曹璐',
        link:'https://www.himmpat.com/browse?ucid=CN-110668809-A&excelToken=new140740A38A74774E96823550A6ECFDE8A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN103588474B ',
        title:'一种包覆结构的磁电复相陶瓷的制备方法', 
        apply: '哈尔滨工业大学',
        dever: '柯华 | 张洪军 | 张利伟 | 莫然 | 王文 | 贾德昌 | 周玉',
        link:'https://www.himmpat.com/browse?ucid=CN-103588474-A&excelToken=newE8765E398D1310EEF29C94154FBEE8C0A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN115677338B ',
        title:'一种Z型六角铁氧体磁电耦合陶瓷材料及其制备方法', 
        apply: '哈尔滨工业大学',
        dever: '李均 | 赵东鹏 | 吴欢桐 | 周忠祥',
        link:'https://www.himmpat.com/browse?ucid=CN-115677338-A&excelToken=newED719DBB4719E354E49483D8EC4ABC9AA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN107010953B ',
        title:'一种单相多铁陶瓷材料及其制备方法', 
        apply: '哈尔滨工程大学',
        dever: '李均 | 白晗 | 周忠祥',
        link:'https://www.himmpat.com/browse?ucid=CN-107010953-A&excelToken=newFB86AEFAA3C9C87E13F05D54180B60C8A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN113030197B ',
        title:'一种气体传感器漂移补偿方法', 
        apply: '哈尔滨工业大学',
        dever: '宋凯 | 姜宗泽 | 袁峰 | 王祁',
        link:'https://www.himmpat.com/browse?ucid=CN-113030197-A&excelToken=newB1755E58A3A913ED81148B366FF65644A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN108181355B ',
        title:'用于二氧化氮气敏传感器的二硫化锡/石墨烯/二氧化锡三元复合气敏材料的制备方法', 
        apply: '哈尔滨工业大学',
        dever: '王铀 | 郑晟良',
        link:'https://www.himmpat.com/browse?ucid=CN-108181355-A&excelToken=new3180761CE12D201CAAFC8C53033FC339A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN103295710B',
        title:'热敏电阻模拟模块及对该模块的电阻输出校准方法', 
        apply: '哈尔滨工业大学',
        dever: '赵光权 | 彭宇 | 刘兆庆 | 易进 | 高万峰 | 张振江',
        link:'https://www.himmpat.com/browse?ucid=CN-103295710-A&excelToken=new526C966EDBB3E43259699288FAA6F1DCA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN109143458B',
        title:'一种在线可调谐双芯光纤偏振器', 
        apply: '哈尔滨工程大学',
        dever: '田凤军 | 张英杰 | 苏镇岚 | 曲洪坤 | 李立',
        link:'https://www.himmpat.com/browse?ucid=CN-109143458-A&excelToken=newBC53EDE0A45F18AF1D021A58A22CCDA0A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN109765426B',
        title:'基于宽频谱激励信号的系统模型参数快速辨识方法', 
        apply: '哈尔滨工业大学',
        dever: '孙英博 | 王常虹 | 夏红伟 | 王艺蒙',
        link:'https://www.himmpat.com/browse?ucid=CN-109765426-A&excelToken=new300B8B951C7C84161DB38CC88962B0FCA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN113885298B',
        title:'一种磁悬浮式光刻机掩模台', 
        apply: '哈尔滨工业大学',
        dever: '吴剑威 | 李昌其 | 赵鹏越 | 郑健 | 王继尧 | 韦威威 | 谭久彬',
        link:'https://www.himmpat.com/browse?ucid=CN-113885298-A&excelToken=new121D042F7FFC6A240BF0B647DE49579CA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN105137717B',
        title:'基于CompBct DifferentiBl Evolution算法的光刻机掩模台微动台的机械参数软测量方法', 
        apply: '哈尔滨工业大学',
        dever: '陈兴林 | 陈震宇 | 刘杨 | 付雪微',
        link:'https://www.himmpat.com/browse?ucid=CN-105137717-A&excelToken=new1379FA99B532101B1CA9C8955DEE818BA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN104977816B',
        title:'基于CompBct PBrticle SwBrm OptimizBtion算法的光刻机掩模台微动台的机械参数软测量方法', 
        apply: '哈尔滨工业大学',
        dever: '陈兴林 | 陈震宇 | 刘杨 | 付雪微',
        link:'https://www.himmpat.com/browse?ucid=CN-104977816-A&excelToken=new52DD8D3F67828A72470C104068566FA0A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN116819902B',
        title:'超精密光刻装备六自由度分散式复合控制系统及控制方法', 
        apply: '哈尔滨工业大学',
        dever: '宋法质 | 刘杨 | 陈帅奇 | 崔宁 | 谭久彬',
        link:'https://www.himmpat.com/browse?ucid=CN-116819902-A&excelToken=new9BB394377740AB2DA769873B58512C3AA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: 'CN104914682B',
        title:'光刻机换台过程中公转电机残留震荡抑制的控制方法', 
        apply: '哈尔滨工业大学',
        dever: '陈兴林 | 韩记晓 | 宋法质 | 万勇利 | 张常江 | 刘洋 | 赵为志 | 何良辰 | 宋跃 | 陈震宇',
        link:'https://www.himmpat.com/browse?ucid=CN-104914682-A&excelToken=newC04FD8AC778978C3B17562D364DAAEC8A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5'
        },
        {
        pubNumber: ' CN103439866B ',
        title:'基于VxWorks的光刻机双工件台通信方法及装置', 
        apply: '哈尔滨工业大学',
        dever: '陈兴林 | 刘川 | 刘杨 | 毕延帅',
        link:'https://www.himmpat.com/browse?ucid=CN-103439866-A&excelToken=newAC25741519976B48CB2B0CB289A044A8A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
        pubNumber: 'CN110434265B ',
        title:'一种直升机用大模数直齿圆柱齿轮精密锻造冷精整成形方法及其模具', 
        apply: '哈尔滨工业大学',
        dever: '宗影影 | 肖爽 | 邵斌 | 王继伟 | 单德彬 | 郭斌',
        link:'https://www.himmpat.com/browse?ucid=CN-110434265-A&excelToken=new178D6B4852A2450890612D1C26B35C6BA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
          pubNumber: 'CN105259536B',
          title:'一种基于L型天线阵列的相位干涉仪测向装置及解算方法', 
          apply: '哈尔滨工程大学',
          dever: '张文旭 | 阮帅 | 李晨 | 陈亚静 | 吴亚桐',
          link:'https://www.himmpat.com/browse?ucid=CN-105259536-A&excelToken=newA85DB1470A6AADB08D37767E2C67B920A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
          pubNumber: 'CN110311223B ',
          title:'信号增强型等离子体隐身天线窗', 
          apply: '哈尔滨工业大学',
          dever: '聂秋月 | 陈培奇 | 张仲麟 | 李博文',
          link:'https://www.himmpat.com/browse?ucid=CN-110311223-A&excelToken=new6C71DF2353E184C5009E7E28C14A7D72A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
          pubNumber: 'CN106329106B ',
          title:'一种基于SIW技术的宽带高隔离度低交叉极化双极化微带天线阵', 
          apply: '哈尔滨工程大学',
          dever: '王伟 | 王敬 | 刘爱萌 | 魏震宇 | 郭猛',
          link:'https://www.himmpat.com/browse?ucid=CN-106329106-A&excelToken=newBD0D5836A72E68613DCC0756841268AEA5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        },
        {
          pubNumber: 'CN105552554B ',
          title:'一种适用于雷达天线边块的三自由度调姿装置及调姿方法', 
          apply: '哈尔滨工业大学',
          dever: '彭高亮 | 薛渊 | 韩锐 | 孙瑜',
          link:'https://www.himmpat.com/browse?ucid=CN-105552554-A&excelToken=new41CEC908C7539DB56CE8581A36616A43A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
          },
        {
          pubNumber: 'CN105424220B',
          title:'一种基于表面等离激元的温度传感器', 
          apply: '哈尔滨工业大学',
          dever: '掌蕴东 | 李慧 | 吴泳锋 | 于长秋 | 张拓 | 袁萍',
          link:'https://www.himmpat.com/browse?ucid=CN-105424220-A&excelToken=newB66B0D7DF2F9E644428E43AF71E25617A5D2CE3D39CC120731764F3FF1F2A283_CAD26DC2D28F11933780BAD3438CBDC5 '
        }
    ])
    
    const tableData2 = ref([
      {row1: 'CN105303526A',row2:'CN201510594428.8', row3: '2015-09-17',row4: '一种基于海岸线数据及频谱分析的舰船目标检测方法',row5: '哈尔滨工业大学|哈尔滨华凡传感技术有限公司',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-101434728-A&excelToken=new425BEA035449FE6CE88235178DE51B13A0C5C12315373AE82E6F4B3B1D9662DD_24D9087670099ADD93B19765F5E03444'},
      {row1: 'CN110044511A',row2:'CN201910350879.5', row3: '2019-04-28',row4: '一种采用非接触电极的高稳定长度伸缩模石英温度传感器',row5: '哈尔滨华凡传感技术有限公司',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-110044511-A&excelToken=newBF9DDC0D939774C1DA24E17B0D6C5F07EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN109580030A',row2:'CN201910023542.3', row3: '2019-01-10',row4: '一种具有多枚箭形振臂的高精度谐振式石英温度传感器',row5: 'HARBIN HUAFAN SENSING TECHNOLOGY CO.,LTD.',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-109580030-A&excelToken=new95D0EC221EAC4B9C765EA4F7B42957A0EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN104589674A',row2:'CN201510076710.7', row3: '2015-02-13',row4: '飞机用复合材料低成本简易模具及快速制造方法',row5: '哈尔滨新科锐工艺装备制造有限公司',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-104589674-A&excelToken=new807C059DAB78F03D90561B420CAE2A4FEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN102489802A',row2:'CN201110429417.6', row3: '2011-12-20',row4: '一种微冲压模具原位制造装置',row5: '哈尔滨广播器材有限责任公司',row6:'有效',link:'https://www.himmpat.com/browse?ucid=CN-102489802-A&excelToken=newE1CB3D4D8E7E9BCEE0AA8944382B1E62EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN116707689A',row2:'CN202310818506.2', row3: '2023-07-05',row4: '一种中波广播发射机的监测设备布点方法及系统',row5: '哈尔滨广播器材有限责任公司',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-116707689-A&excelToken=newC9D32C9F519AB25AC372A28E417C6862EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN111863606A',row2:'CN202010735237.X', row3: '2020-07-28',row4: '一种抗辐射功率晶体管及其制备方法',row5: '哈尔滨工业大学',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-111863606-A&excelToken=newD15E76FA9D237B702332B55DA15C60CAEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN111863607A',row2:'CN202010735238.4', row3: '2020-07-28',row4: '一种抗辐射功率晶体管及其制备方法',row5: '哈尔滨工业大学',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-111863607-A&excelToken=newC3D680D34CA54788D34AEFE19D5536B7EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN115856397A',row2:'CN202211582488.4', row3: '2022-12-09',row4: '一种等离子点火系统的放电电压测量辅助工具',row5: '哈尔滨工程大学',row6:'有效',link:'https://www.himmpat.com/browse?ucid=CN-115856397-A&excelToken=new895EE6C91ED9DFDA86181D7A54E331C2EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN102868908A',row2:'CN201110184906.X', row3: '2011-07-04',row4: '高效流媒体播放方法和装置',row5: '哈尔滨融智达网络科技有限公司',row6:'失效',link:'https://www.himmpat.com/browse?ucid=CN-102868908-A&excelToken=new0056449D541574EEC958234B31910448EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN108964731A',row2:'CN201810966467.X', row3: '2018-08-23',row4: '基于快速卷积的无循环前缀滤波混合载波连续流传输方法',row5: '哈尔滨工业大学',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-108964731-A&excelToken=new8CB7D18F2A917062E55B3C34CC0A69DBEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN108956742A',row2:'CN201810820855.7', row3: '2018-07-24',row4: '一种石墨烯场效应晶体管阵列生物传感器及其制备方法和检测方法',row5: '哈尔滨工程大学 | 中国电子科技集团公司第四十九研究所',row6:'有效',link:'https://www.himmpat.com/browse?ucid=CN-108956742-A&excelToken=newFA6245DBEF0B816E2300CC28431E517CEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN101481475B',row2:'CN200810023192.2', row3: '2008-07-17',row4: '紫外光交联膨胀型阻燃聚烯烃电缆绝缘护套料及制备方法',row5: '黑龙江省润特科技有限公司 | 中国科学技术大学',row6:'有效',link:'https://www.himmpat.com/browse?ucid=CN-101481475-B&excelToken=new54775C4BE5DA4D2CDC96AD8748464B3EEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN101434728A',row2:'CN200810244782.8', row3: '2008-12-04',row4: '紫外光交联三元乙丙橡胶电缆绝缘料及其制备方法',row5: '黑龙江省润特科技有限公司 | 中国科学技术大学',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-101434728-A&excelToken=newFF6A1F18DFBBCD225F9DEC5F02B6F6C2EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
    ])
    function clearScrll() {
      clearInterval(timer)
      timer = null;
    }
    function scrollUp() {
         nextTick(()=>{
          const myTab = tableList.value.$refs.bodyWrapper.getElementsByClassName('el-scrollbar__wrap')[0];
          const tableScroll = ref(true);
          myTab.addEventListener('mouseover',()=>{
            tableScroll.value = false;
          })
          myTab.addEventListener('mouseout',()=>{
            tableScroll.value = true;
          })
          timer = setInterval(()=>{
            if(tableScroll.value) {
              myTab.scrollTop += 1;
              if(myTab.clientHeight + myTab.scrollTop >= myTab.scrollHeight) {
                myTab.scrollTop = 0;
              }
            }
          },150)
         })
    }
    onMounted(() => {
      scrollUp();
    });
    onUnmounted(() => {
      clearScrll();
    });
   return {tableData1, tableData2, tableList,  scrollUp, clearScrll, timer};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p{
  color: #fff;
  padding-top: 20px;
  padding-left: 20px;
}
.table{
  color: #fff;
  text-align: center;
}
.table div.text{
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
.table-data{
  overflow: hidden;
}
.el-table :deep()tr{
  background-color: transparent!important;
  border: none;

}
.el-table {
  background-color:  transparent!important;
}
.el-table :deep() tr th{
background-color: transparent!important;
border: none!important;
font-size: 16px;
color: #2C6AE8;
}
.el-table :deep() tr td{
  border: none!important;
  color: #80D9FB;
  font-size: 16px;
}
.tablebox{
  padding:10px 30px;
  margin-bottom: 10px;
  padding-bottom: 30px;
}
.el-table :deep() tr {border: none!important;}
.el-table :deep()tbody tr:hover>td { background-color:#000746!important;}
.el-table__body tr.hover-row>td { background-color: #000746;}
</style>
<style>
.myTooltips{
  font-size: 16px!important;
  max-width: 200px;
}
</style>
